import React, { useEffect } from 'react';
import _startCase from 'lodash/startCase';

function useTitle(uri: string) {
  const [title] = React.useState<string>('AW Forms');
  const getFormName = () => {
    const uriArr = uri.split('/');
    const formIndex = uriArr.indexOf('form');

    if (formIndex !== -1 && formIndex + 1 < uriArr.length) {
      const formName = uriArr[formIndex + 1];
      switch (formName) {
        case 'incident':
          return 'Incident';
        case 'cabin-event':
          return 'CER';
        case 'safety-event':
          return 'SER';
        case 'flight-operation-notification':
          return 'FON';
        case 'flight-event':
          return 'FER';
        case 'dispatch-event':
          return 'DER';
        default:
          return undefined;
      }
    }

    return undefined;
  };

  const getPageName = () => {
    const uriArr = uri.split('/');
    const pageNameIndex = uriArr.indexOf('form');
    if (pageNameIndex !== -1 && pageNameIndex + 3 < uriArr.length) {
      return uriArr[pageNameIndex + 3];
    }
    return undefined;
  };
  useEffect(() => {
    let prevTitle = title;
    const formName = getFormName();
    const pageName = getPageName();
    if (formName) {
      prevTitle = `${prevTitle} | ${formName}`;
    }
    if (pageName) {
      prevTitle = `${prevTitle} | ${_startCase(pageName)}`;
    }

    document.title = prevTitle;
    return () => {
      document.title = title;
    };
  }, [uri]);
}

export default useTitle;
